import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';

import { ThemeProvider } from '@shared/theme/ThemeProvider';
import { ToastProvider } from '@shared/ui/toast/ToastProvider';

import { router } from './router';

/**
 * Providers only. `App` sets no `lang`, no `dir` and no theme attribute —
 * `index.html` owns all three and reaches the browser first, which is what
 * keeps direction and theme from flickering on first paint.
 */
export function App({ queryClient }: { queryClient: QueryClient }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
